import styled from 'styled-components';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { Colors } from '../../../theme';
import { button, subTitle2 } from '../styles/fonts';
export const StyledMuiAccordion = styled(MuiAccordion) `
  width: 100%;
  margin-bottom: 16px;
  border: 1px solid ${Colors.cream100};
  border-radius: 16px;

  & .main {
    padding: 0 0 16px;
  }

  & .MuiCollapse-root {
    padding: 0 16px;

    & .MuiTypography-root {
      padding: 8px;
      ${button};
    }
  }

  .MuiCollapse-wrapper {
    padding-bottom: 16px;
  }

  &::before {
    display: none;
  }
`;
export const StyledAccordionSummary = styled(MuiAccordionSummary) `
  padding: 16px;

  & .MuiTypography-root {
    color: ${Colors.grey900};
    ${subTitle2};
  }

  & .MuiAccordionSummary-content {
    margin: 0;
  }
`;
export const StyledAccordionDetails = styled(MuiAccordionDetails) `
  padding: 0;
`;
//# sourceMappingURL=styles.js.map